<div class="container-wrapper">
  <div class="main-wrapper">

    <div class="content-wrapper">

      <div class="faq-section" *ngIf="!showLoader">
        <h2 class="main-heading font-18 font-500">Most Viewed FAQs
          ({{questionCount}})</h2>
        <div class="accordian-wrapper" >
          <ul *ngFor="let item of finalQuestionArray">
            <li (click)="goTosubCategoryAnswers(item.id, item.category.id, item.permalink)">
              <h3 class="label">{{item.title}}</h3>
              <span class="icon-right-chevron"></span>
            </li>
          </ul>

          <div class="view-more">
            <a class="fw-500" href="javascript:;" alt="View More" title="View More" (click)="getViewMore(viewChange)">
              {{ viewChange }}
              <span [ngClass]="{
                      'icon-chevron-up': viewChange === 'View Less',
                      'icon-chevron-down': viewChange === 'View More'
                  }"></span>
            </a>
          </div>
        </div>        
      </div>

      <div class="faq-section" *ngIf="showLoader">
        <h3 class="main-heading font-18 font-500"><span class="loading--shimmer w30"></span>
          </h3>
        <div class="accordian-wrapper">
          <ul>
            <li>
              <span class="loading--shimmer w80"></span>
              <span class="loading--shimmer w10"></span>
            </li>
            <li>
              <span class="loading--shimmer w80"></span>
              <span class="loading--shimmer w10"></span>
            </li>
            <li>
              <span class="loading--shimmer w80"></span>
              <span class="loading--shimmer w10"></span>
            </li>
          </ul>

          <div class="view-more">
            <a class="fw-500">
              <span class="loading--shimmer w10"></span>
              <span class="loading--shimmer w10"></span>
            </a>
          </div>

        </div>
      </div>

      <div class="knowledge-base" *ngIf="!showKBloader">
        <h2 class="main-heading">Knowledge Base</h2>
        <div class="row">
          <div class="col-6" *ngFor="let item of mainBaseArray; index as i">
            <div class="card" (click)="goToKnowledgeBaseComponent(item.permalink, item.name)">
              <h3>{{ item.name }}</h3>
            </div>
          </div>
        </div>
      </div>

      <div class="knowledge-base" *ngIf="showKBloader">
        <h2 class="main-heading"><span class="loading--shimmer w40"></span></h2>
        <div class="row">
          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>

          <div class="col-6">
            <div class="card">
              <h3><span class="loading--shimmer w30"></span></h3>
            </div>
          </div>
        </div>
      </div>

      <hr>

      <!-- <div class="create-ticket-wrapper" *ngIf="isLoggedIn == 'Y'"> -->
      <div class="create-ticket-wrapper">
        <h2 class="main-heading">Still Stuck?</h2>
        <h3 class="sub-heading">Have you tried looking for an answer?</h3>
        <p>
          Create a ticket and we will respond as soon as possible, or you can
          return later.
        </p>
        <div class="row-wrapper">
          <div class="ticket-button-wrapper">
            <button class="primary-btn" (click)="goToCreateTicket()">Create a Ticket</button>
            <!-- <button class="transparent-btn fw-500">Or contact our support</button> -->
            <button class="transparent-btn fw-500" (click)="letsChat()">or Chat with us</button>
          </div>

          <div class="phone-icon-container">
              <a href="tel:8976689766" class="phone-icon">
                <img class="" src="https://images.5paisa.com/forum/Call.png" alt="Phone Icon"/>
              </a>
          </div>
        </div> 
      </div>
    </div>
  </div>
</div>